import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets.app/images/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-27edd206"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stepper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "stepper__logo",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "stepper__section-name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "•", -1))

import { QuestionnaireView } from '@/models/onboarding'
import { PublicInterface } from '@/models/interfaces'


export default /*#__PURE__*/_defineComponent({
  __name: 'Stepper',
  props: {
    view: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(" Step " + _toDisplayString(__props.view.currentSectionIndex) + " ", 1),
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(__props.view.currentSection.title), 1)
    ]),
    _createVNode(_Transition, {
      name: "slide",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", {
          key: __props.view.currentSectionIndex,
          class: "stepper__steps"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.view.sections.slice(1), (section, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: section.id,
              class: _normalizeClass(["stepper__step", {
            'stepper__step--prev': index + 1 < __props.view.currentSectionIndex,
            'stepper__step--current': index + 1 === __props.view.currentSectionIndex,
            'stepper__step--next': index + 1 > __props.view.currentSectionIndex,
          }]),
              style: _normalizeStyle({
            '--section-progress': __props.view.currentSectionProgress,
          })
            }, null, 6))
          }), 128))
        ]))
      ]),
      _: 1
    })
  ]))
}
}

})